export default "__VITE_ASSET__hd_BXCx25dCCiTFVAMV3Fg__"